import addParam from './addParam'

/**
 * 兼容给带 hash 的 url 增加参数
 * 传递的参数同 addParam
 * @param arr
 * @param url
 * @return {string}
 */
export default function addGetParam(arr, url) {
  // 取出 hash 第一段 & 第二段
  let [prefix, suffix] = url.split('#')

  // 给第一段增加参数
  let addedUrl = addParam(arr, prefix)

  // 若存在第二段，则拼接后返回
  if (suffix) {
    return [addedUrl, '#', suffix].join('')
  }

  return addedUrl
}